module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.loading.referralEmails) ? _c('spinner') : _c('form', {
    attrs: {
      "data-vv-scope": "email-settings"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('form-select', {
    attrs: {
      "label": "Select email type",
      "name": "email-type",
      "validation-scope": "email-settings",
      "validators": "required",
      "options": _vm.types
    },
    model: {
      value: (_vm.currentType),
      callback: function($$v) {
        _vm.currentType = $$v
      },
      expression: "currentType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('shortcodes-editor', {
    attrs: {
      "label": "Body",
      "name": "body",
      "validation-scope": "new-email",
      "validators": "required",
      "rows": "20",
      "shortcodes": _vm.shortcodes
    },
    model: {
      value: (_vm.data[_vm.currentType]),
      callback: function($$v) {
        _vm.$set(_vm.data, _vm.currentType, $$v)
      },
      expression: "data[currentType]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6aaee397","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/referral/ReferralEmailSettings.vue
// module id = 1685
// module chunks = 1